import enMessages from '../locales/en.json';
import zhMessages from '../locales/zh.json';

export const localeMessages: { [key: string]: Record<string, string> } = {
  en: enMessages,
  zh: zhMessages,
};
